"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateNoFallback = exports.t = void 0;
const i18next_1 = __importDefault(require("i18next"));
const t = (key, options) => {
    try {
        const translation = i18next_1.default.t(key, options ?? {});
        if ((!translation || translation === key) && __DEV__) {
            // eslint-disable-next-line no-console
            console.warn('Missing translation for %o', key);
        }
        return translation ?? key;
    }
    catch (error) {
        if (__DEV__) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
        return key;
    }
};
exports.t = t;
const translateNoFallback = (key, options) => {
    const translation = (0, exports.t)(key, options);
    if (!translation || translation === key) {
        return null;
    }
    return translation;
};
exports.translateNoFallback = translateNoFallback;
